import i18next from 'i18n';

const MR_VALUE = '1';
const MRS_VALUE = '2';
const MISS_VALUE = '3';
const MS_VALUE = '4';

export const genderOptions = [
  {
    label: i18next.t('LABEL_MRS'),
    value: MRS_VALUE,
  },
  {
    label: i18next.t('LABEL_MR'),
    value: MR_VALUE,
  },
];

export const genderOptionsUk = [
  {
    label: i18next.t('LABEL_MRS'),
    value: MRS_VALUE,
  },
  {
    label: i18next.t('LABEL_MS'),
    value: MS_VALUE,
  },
  {
    label: i18next.t('LABEL_MISS'),
    value: MISS_VALUE,
  },
  {
    label: i18next.t('LABEL_MR'),
    value: MR_VALUE,
  },
];
